import { sendEvents } from '@fiverr-private/futile';

export function reportPageView(requestContext) {
    const { current_user } = requestContext;
    const type = typeof current_user === 'undefined' ? 'pro_homepage.logged_out' : 'pro_homepage.logged_in';

    const eventData = {
        type,
        group: 'page_view'
    };

    sendEvents(eventData);
}

export function reportClick(name, data) {
    const {
        categoryId,
        categoryName,
        subCategoryId,
        subCategoryName,
        title,
        position,
        pageCtxId
    } = data;

    const eventData = {
        type: `${name}.sub_category_click`,
        group: 'pro_navigation',
        current_page_type: 'homepage',
        category: {
            id: categoryId,
            name: categoryName
        },
        sub_category: {
            id: subCategoryId,
            name: subCategoryName
        },
        listings: {
            page_ctx_id: pageCtxId,
            carousel_title: title,
            carousel_position: position
        }
    };

    sendEvents(eventData);
}



// WEBPACK FOOTER //
// ./src/common/HomePage/lib/reportEvent.js